import { c as _c } from "react/compiler-runtime";
import { Icon, Typography } from "@/shared/ui/atoms";
interface HospitalHomepageLinkProps {
  homepageUrl?: string;
  label: string;
}

/** 검증이 완료된 병원 공식 홈페이지만 새 탭으로 연다. */
const HospitalHomepageLink = t0 => {
  const $ = _c(8);
  const {
    homepageUrl,
    label
  } = t0;
  let t1;
  if ($[0] !== homepageUrl) {
    t1 = homepageUrl?.trim();
    $[0] = homepageUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const url = t1;
  if (!url) {
    return null;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Icon src="/icons/global.svg" alt="" width={16} height={16} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== label) {
    t3 = <Typography as="span" size={14} lineHeight={20} className="underline underline-offset-2">{label}</Typography>;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3 || $[6] !== url) {
    t4 = <a href={url} target="_blank" rel="noopener noreferrer nofollow" className="inline-flex w-fit items-center gap-2 text-gray-700 hover:text-primary-700">{t2}{t3}</a>;
    $[5] = t3;
    $[6] = url;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default HospitalHomepageLink;